import { Redirect } from 'expo-router';
import { useAtomValue } from 'jotai';
import React from 'react';

import ConnectInstitutionSuccess from '../../../holistic/components/ConnectInstitutionSuccess';
import { selectedConnectionIdAtom } from '../../../holistic/state/HolisticAtoms';

const ConnectInstitutionSuccessScreen = () => {
    const selectedConnectionId = useAtomValue(selectedConnectionIdAtom);
    if (selectedConnectionId == null) {
        return <Redirect href="/" />;
    }

    return <ConnectInstitutionSuccess />;
};

export default ConnectInstitutionSuccessScreen;
